<section class="flex min-h-0 flex-1 flex-col overflow-hidden">
  @if (!classroomUrl()) {
    <div class="flex min-h-0 flex-1 flex-col gap-6 overflow-auto px-6 py-6">
      <h1 class="text-2xl font-bold">{{ 'door.studentHeading' | transloco }}</h1>

      @if (!roomId()) {
        <p role="alert">{{ 'door.missingRoom' | transloco }}</p>
      } @else if (joining()) {
        <p role="status">{{ 'door.joining' | transloco }}</p>
      } @else {
        <form class="flex max-w-sm flex-col gap-3" (submit)="submitJoin($event)">
          <label class="font-semibold" for="student-name">{{ 'door.yourName' | transloco }}</label>
          <input
            id="student-name"
            class="rounded border border-[var(--mat-sys-outline)] px-3 py-2"
            name="student-name"
            autocomplete="name"
            [value]="name()"
            (input)="updateNameFromInput($event)"
            required
          />
          <button
            type="submit"
            class="w-fit rounded-full px-4 py-2 text-sm font-semibold hover:bg-[var(--mat-sys-on-surface)]/10"
          >
            {{ 'door.join' | transloco }}
          </button>
        </form>
      }

      @if (error(); as message) {
        <p role="alert">{{ message.startsWith('door.') ? (message | transloco) : message }}</p>
      }
    </div>
  } @else {
    <h1 class="sr-only">{{ 'door.studentHeading' | transloco }}</h1>
    @if (error(); as message) {
      <p class="px-6 py-3" role="alert">
        {{ message.startsWith('door.') ? (message | transloco) : message }}
      </p>
    }
  }

  @if (classroomUrl(); as url) {
    <app-classroom-frame class="min-h-0 flex-1" [url]="url" />
  }
</section>
